import { copy } from "../content/copy";

export function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div>{copy.footer.copyright}</div>
        <nav className="footer__links" aria-label="Footer">
          <a href={`mailto:${copy.footer.contact}`}>{copy.footer.contact}</a>
          <a href="#problem">Problem</a>
          <a href="#product">Product</a>
        </nav>
      </div>
    </footer>
  );
}
